import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../../../redux/actions/authActions';
import { sendAccountActivationRequest } from "../../../redux/actions/emailActions";
import './login.css';
import ForgotPasswordModal from "./ForgotPasswordModal";

/* ── Charte CICADAHR ─────────────────────────────────────
   Navy   #0e2046  — titres, accents, focus, liens
   Coral  #334785  — CTA principal, highlights
   Lato   police officielle
───────────────────────────────────────────────────────── */

const MODAL_CSS = `
  .cm-backdrop {
    position: fixed; inset: 0; z-index: 999;
    background: rgba(14, 32, 70, 0.55);
    backdrop-filter: blur(5px);
    display: flex; align-items: center; justify-content: center;
    padding: 20px;
    animation: cmFadeIn .22s ease;
  }
  @keyframes cmFadeIn { from { opacity: 0 } to { opacity: 1 } }

  .cm-card {
    background: #fff;
    border-radius: 16px;
    width: 100%; max-width: 380px;
    box-shadow:
      0 24px 64px rgba(14, 32, 70, .22),
      0 0 0 1px rgba(14, 32, 70, .07);
    overflow: hidden;
    font-family: 'Lato', sans-serif;
    animation: cmSlideIn .3s cubic-bezier(.34, 1.4, .64, 1);
  }
  @keyframes cmSlideIn {
    from { opacity: 0; transform: translateY(16px) scale(.96) }
    to   { opacity: 1; transform: translateY(0)    scale(1)   }
  }

  .cm-head {
    background: #0e2046;
    padding: 22px 24px 20px;
    position: relative; overflow: hidden;
  }
  .cm-head::before {
    content: ''; position: absolute;
    top: -24px; right: -24px;
    width: 90px; height: 90px; border-radius: 50%;
    background: rgba(238, 100, 95, .12);
  }
  .cm-head::after {
    content: ''; position: absolute;
    bottom: -30px; left: 20px;
    width: 70px; height: 70px; border-radius: 50%;
    background: rgba(255, 255, 255, .04);
  }

  .cm-head-icon {
    width: 38px; height: 38px; border-radius: 10px;
    background: rgba(238, 100, 95, .18);
    border: 1px solid rgba(238, 100, 95, .3);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 11px; position: relative; z-index: 1;
  }

  .cm-head-title {
    font-family: 'LatoBold', 'Lato', sans-serif;
    font-size: 15px; font-weight: 700;
    color: #fff; margin: 0 0 3px;
    letter-spacing: .1px; position: relative; z-index: 1;
  }
  .cm-head-sub {
    font-size: 11.5px; color: rgba(255,255,255,.55);
    margin: 0; line-height: 1.5; position: relative; z-index: 1;
  }
  .cm-head-sub.sent { color: rgba(238, 100, 95, .85); }

  .cm-close {
    position: absolute; top: 12px; right: 12px; z-index: 2;
    width: 26px; height: 26px; border-radius: 7px;
    background: rgba(255,255,255,.1); border: none;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    color: rgba(255,255,255,.7); transition: background .15s;
  }
  .cm-close:hover { background: rgba(255,255,255,.2); }

  .cm-body { padding: 20px 24px 24px; }

  .cm-label {
    display: block; font-size: 10.5px; font-weight: 700;
    color: #0e2046; margin-bottom: 5px;
    letter-spacing: .5px; text-transform: uppercase;
  }

  .cm-field { position: relative; margin-bottom: 15px; }

  .cm-field-ico {
    position: absolute; left: 11px; top: 50%;
    transform: translateY(-50%);
    display: flex; align-items: center; pointer-events: none;
  }

  .cm-input {
    width: 100%; padding: 9px 11px 9px 35px;
    border: 1.5px solid #dce3f0;
    border-radius: 8px; font-size: 12.5px;
    font-family: 'Lato', sans-serif;
    color: #0e2046; background: #f7f9fc;
    outline: none; transition: all .2s; box-sizing: border-box;
  }
  .cm-input:focus {
    border-color: #0e2046;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(14, 32, 70, .08);
  }
  .cm-input::placeholder { color: #aab4cb; font-size: 12px; }

  .cm-btn {
    width: 100%; padding: 11px;
    background: #334785;
    color: #fff; border: none; border-radius: 8px;
    font-family: 'LatoBold', 'Lato', sans-serif;
    font-size: 13px; font-weight: 700;
    cursor: pointer; transition: all .2s;
    display: flex; align-items: center; justify-content: center; gap: 7px;
    letter-spacing: .2px;
  }
  .cm-btn:disabled { opacity: .6; cursor: not-allowed; }
  .cm-btn:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(51, 71, 133, .38);
}

  .cm-btn-outline {
    width: 100%; padding: 10px;
    background: transparent;
    color: #0e2046; border: 1.5px solid #0e2046;
    border-radius: 8px;
    font-family: 'Lato', sans-serif;
    font-size: 12.5px; font-weight: 600;
    cursor: pointer; transition: all .2s;
    display: flex; align-items: center; justify-content: center; gap: 7px;
    margin-top: 10px;
  }
  .cm-btn-outline:hover { background: #f0f3f9; }

  .cm-hr { height: 1px; background: #edf1f7; margin: 14px 0; }

  .cm-hint {
    font-size: 11px; color: #8a96b0;
    text-align: center; line-height: 1.55;
    font-family: 'LatoLight', 'Lato', sans-serif;
  }
  .cm-hint a { color: #0e2046; text-decoration: none; font-weight: 700; }
  .cm-hint a:hover { text-decoration: underline; }

  .cm-err {
    background: #fff5f5; color: #c0392b;
    border: 1px solid #fdc5c3; border-radius: 8px;
    padding: 8px 11px; font-size: 11.5px;
    margin-bottom: 13px;
    display: flex; gap: 7px; align-items: flex-start;
    font-family: 'Lato', sans-serif;
  }

  .cm-success { text-align: center; padding: 4px 0 2px; }

  .cm-success-ring {
    width: 58px; height: 58px; border-radius: 50%;
    background: linear-gradient(135deg, #fff0ef, #ffe4e3);
    border: 2px solid rgba(238,100,95,.2);
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 14px;
    animation: ringPop .4s cubic-bezier(.34,1.56,.64,1);
  }
  @keyframes ringPop {
    from { transform: scale(0); opacity: 0 }
    to   { transform: scale(1); opacity: 1 }
  }

  .cm-check-path {
    stroke-dasharray: 32;
    stroke-dashoffset: 32;
    animation: drawCheck .5s .2s ease forwards;
  }
  @keyframes drawCheck { to { stroke-dashoffset: 0 } }

  .cm-success-title {
    font-family: 'LatoBold', 'Lato', sans-serif;
    font-size: 15px; font-weight: 700;
    color: #0e2046; margin: 0 0 6px;
  }
  .cm-success-desc {
    font-size: 12px; color: #5a6680;
    line-height: 1.65; margin: 0 0 18px;
    font-family: 'LatoLight', 'Lato', sans-serif;
  }
  .cm-success-desc strong { color: #334785; font-family: 'LatoBold','Lato',sans-serif; }

  .cm-success-badge {
    display: inline-flex; align-items: center; gap: 5px;
    background: #fff5f5; border: 1px solid rgba(238,100,95,.25);
    border-radius: 20px; padding: 4px 12px;
    font-size: 11px; color: #334785;
    font-family: 'Lato', sans-serif;
    margin-bottom: 16px;
    animation: cmFadeIn .4s .3s both;
  }

  .cm-spin {
    width: 13px; height: 13px; border-radius: 50%;
    border: 2px solid rgba(255,255,255,.35);
    border-top-color: #fff;
    animation: spin .7s linear infinite;
    display: inline-block; flex-shrink: 0;
  }
  @keyframes spin { to { transform: rotate(360deg) } }

  .cicada-activate-btn {
    width: 100%; padding: 9px 14px; margin-top: 10px;
    background: #f7f9fc;
    border: 1.5px dashed #bbc8e0; border-radius: 8px;
    font-family: 'Lato', sans-serif;
    font-size: 12.5px; font-weight: 600;
    color: #0e2046; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 7px;
    transition: all .2s;
  }
  .cicada-activate-btn:hover {
    background: #edf1f9; border-color: #0e2046;
  }
  .cicada-activate-btn.inactive {
    background: #334785;
    border: none; color: #fff;
    animation: pulseCTA 2s infinite;
  }
  .cicada-activate-btn.inactive:hover {
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(238, 100, 95, .38);
  }
  @keyframes pulseCTA {
    0%,100% { box-shadow: 0 0 0 0 rgba(238,100,95,.3) }
    50%      { box-shadow: 0 0 0 6px rgba(238,100,95,0) }
  }

  .cm-desc {
    font-size: 12px; color: #5a6680;
    line-height: 1.6; margin: 0 0 14px;
    font-family: 'LatoLight', 'Lato', sans-serif;
  }

  .cm-input-wrap {
    position: relative;
    margin-bottom: 15px;
  }

  .cm-input-icon {
    position: absolute; left: 11px; top: 50%;
    transform: translateY(-50%);
    display: flex; align-items: center; pointer-events: none;
  }

  .cm-actions {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .cm-error {
    background: #fff5f5; color: #c0392b;
    border: 1px solid #fdc5c3; border-radius: 8px;
    padding: 8px 11px; font-size: 11.5px;
    margin-bottom: 13px;
    display: flex; gap: 7px; align-items: flex-start;
    font-family: 'Lato', sans-serif;
  }
`;

/* ══════════════════════════════════════════════════════════════
   ACTIVATION MODAL — inchangée (logique + style identiques)
══════════════════════════════════════════════════════════════ */
const ActivationModal = ({ onClose, t, dispatch, activationLoading, activationMessage, activationError }) => {
    const [step, setStep]             = useState('form');
    const [username, setUsername]     = useState('');
    const [localError, setLocalError] = useState(null);

    useEffect(() => {
        if (activationLoading) setStep('sending');
    }, [activationLoading]);

    useEffect(() => {
        if (activationMessage) { setLocalError(null); setStep('done'); }
    }, [activationMessage]);

    useEffect(() => {
        if (activationError) {
            setLocalError(activationError.message || activationError || t("Une erreur est survenue. Veuillez réessayer."));
            setStep('form');
        }
    }, [activationError, t]);

    const handleSend = (e) => {
        e.preventDefault();
        if (!username.trim()) { setLocalError(t("Veuillez saisir votre username.")); return; }
        setLocalError(null);
        dispatch(sendAccountActivationRequest(username.trim()));
    };

    return (
        <>
            <style>{MODAL_CSS}</style>
            <div className="cm-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
                <div className="cm-card">
                    <div className="cm-head">
                        <div className="cm-head-icon">
                            {step === 'done' ? (
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#334785"/>
                                </svg>
                            ) : (
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 1C8.676 1 6 3.676 6 7v1H4a1 1 0 00-1 1v13a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1h-2V7c0-3.324-2.676-6-6-6zm0 2c2.276 0 4 1.724 4 4v1H8V7c0-2.276 1.724-4 4-4zm0 9a2 2 0 110 4 2 2 0 010-4z" fill="#334785"/>
                                </svg>
                            )}
                        </div>
                        <div className="cm-head-title">
                            {step === 'done' ? t("Activation envoyée") : t("Activer mon compte")}
                        </div>
                        <p className={'cm-head-sub' + (step === 'done' ? ' sent' : '')}>
                            {step === 'done'
                                ? t("Votre demande a bien été traitée")
                                : t("Saisissez votre username pour recevoir vos accès")}
                        </p>
                        <button className="cm-close" onClick={onClose} aria-label="close">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                            </svg>
                        </button>
                    </div>

                    <div className="cm-body">
                        {step !== 'done' && (
                            <>
                                <p className="cm-desc">
                                    {t("Entrez votre username. Un email d'activation contenant vos accès temporaires vous sera envoyé si votre compte n'est pas encore activé.")}
                                </p>
                                {localError && (
                                    <div className="cm-error">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" style={{flexShrink:0,marginTop:1}}>
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#c0392b"/>
                                        </svg>
                                        {localError}
                                    </div>
                                )}
                                <form onSubmit={handleSend}>
                                    <label className="cm-label">{t("Username")}</label>
                                    <div className="cm-input-wrap">
                                        <span className="cm-input-icon">
                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 12c2.761 0 5-2.239 5-5S14.761 2 12 2 7 4.239 7 7s2.239 5 5 5zm0 2c-3.314 0-10 1.657-10 4.971V22h20v-3.029C22 15.657 15.314 14 12 14z" fill="#8da2c7"/>
                                            </svg>
                                        </span>
                                        <input
                                            className="cm-input"
                                            type="text"
                                            placeholder={t("Ex : jdoe")}
                                            value={username}
                                            onChange={e => setUsername(e.target.value)}
                                            disabled={activationLoading}
                                            autoFocus
                                        />
                                    </div>
                                    <div className="cm-actions">
                                        <button type="submit" className="cm-btn" disabled={activationLoading}>
                                            {activationLoading ? (
                                                <><span className="cm-spin"/>{t("Envoi en cours...")}</>
                                            ) : (
                                                <>
                                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fill="#fff"/>
                                                    </svg>
                                                    {t("Envoyer l'activation")}
                                                </>
                                            )}
                                        </button>
                                        <button type="button" className="cm-btn-outline" onClick={onClose} disabled={activationLoading}>
                                            {t("Annuler")}
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}

                        {step === 'done' && (
                            <div className="cm-success">
                                <div className="cm-success-ring">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                        <circle cx="13" cy="13" r="11.5" stroke="rgba(238,100,95,.25)" strokeWidth="1.5"/>
                                        <polyline
                                            className="cm-check-path"
                                            points="7,13 11,17 19,9"
                                            fill="none" stroke="#334785"
                                            strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="cm-success-badge">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                        <path d="M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#334785"/>
                                    </svg>
                                    {t("Email envoyé")}
                                </div>
                                <h3 className="cm-success-title">{t("Vérifiez votre boîte mail !")}</h3>
                                <p className="cm-success-desc">
                                    {t("Un email d'activation a été envoyé à :")}{" "}
                                    <strong>{username}</strong>.<br/>
                                    {t("Pensez à vérifier vos spams si besoin.")}
                                </p>
                                <button className="cm-btn" onClick={onClose}>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="#fff"/>
                                    </svg>
                                    {t("Compris, retour à la connexion")}
                                </button>
                                <button
                                    className="cm-btn-outline"
                                    onClick={() => { setStep('form'); setUsername(''); setLocalError(null); }}
                                >
                                    {t("Réessayer avec un autre username")}
                                </button>
                                <div className="cm-hr"/>
                                <p className="cm-hint">{t("Les accès temporaires sont envoyés uniquement si le compte n'est pas encore activé.")}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

/* ══════════════════════════════════════════════════════════════
   LOGIN PAGE
══════════════════════════════════════════════════════════════ */
const Login = () => {
    const { t, i18n }                     = useTranslation();
    const [email, setEmail]               = useState('');
    const [password, setPassword]         = useState('');
    const [rememberMe, setRememberMe]     = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
    const [showActivationModal, setShowActivationModal]         = useState(false);

    const { activationLoading, activationMessage, error: activationError } = useSelector(
        state => state.emails || { activationLoading: false, activationMessage: '', error: null }
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, error, isLogged, isFirstLogin, accountStatus } = useSelector(
        state => state.auth || { loading: false, error: null, isLogged: false, isFirstLogin: false, accountStatus: null }
    );

    const isInactive = accountStatus === 'inactive';

    useEffect(() => {
        if (isLogged && !isFirstLogin) navigate('/cards', { replace: true });
        if (isFirstLogin) setShowActivationModal(true);
    }, [isLogged, isFirstLogin, navigate]);

    const isRTL = i18n.language?.startsWith('ar');

    useEffect(() => {
        document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
        document.documentElement.setAttribute('lang', i18n.language);
        document.body.classList.toggle('rtl-layout', isRTL);
    }, [i18n.language, isRTL]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(loginRequest({ username: email, password, rememberMe }));
    };

    const getBackgroundClass = () => {
        if (isRTL) return 'rtl rtl-bg';
        if (i18n.language?.startsWith('en')) return 'en-bg';
        return '';
    };

    return (
        <>
            <style>{MODAL_CSS}</style>

            <div className={'login-container ' + getBackgroundClass()}>
                <div className="login-box">
                    <h1>{t('Connexion sécurisée')}</h1>
                    <h4>{t('Accédez à votre espace CICADAHR')}</h4>

                    {/* Erreur login */}
                    {error && (
                        <div style={{
                            background: 'rgba(255,245,245,0.9)', color: '#c0392b',
                            padding: '9px 13px', borderRadius: '10px',
                            marginBottom: '13px', border: '1px solid #fdc5c3',
                            fontSize: '12px', display: 'flex', gap: '8px', alignItems: 'center',
                            fontFamily: 'Lato, sans-serif', backdropFilter: 'blur(4px)',
                        }}>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="#c0392b" style={{flexShrink:0}}>
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                            </svg>
                            {error.message || t('Identifiants incorrects.')}
                        </div>
                    )}

                    {/* Bannière compte inactif */}
                    {isInactive && (
                        <div style={{
                            background: 'rgba(255,251,235,0.9)', border: '1px solid #fde68a',
                            borderRadius: '10px', padding: '9px 13px',
                            marginBottom: '13px', fontSize: '11.5px', color: '#92400e',
                            display: 'flex', alignItems: 'center', gap: '8px',
                            fontFamily: 'Lato, sans-serif', backdropFilter: 'blur(4px)',
                        }}>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="#d97706" style={{flexShrink:0}}>
                                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                            </svg>
                            {t("Votre compte n'est pas encore activé. Cliquez ci-dessous.")}
                        </div>
                    )}

                    {/* Formulaire */}
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="input-wrapper">
                                <svg className="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#0e2046"/>
                                </svg>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    placeholder={t('Entrez votre email')}
                                    required
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="input-wrapper">
                                <svg className="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" fill="#0e2046"/>
                                </svg>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    placeholder={t('Entrez votre mot de passe')}
                                    required
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="toggle-password"
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={loading}
                                >
                                    {showPassword ? (
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C21.07 15.49 22.26 13.86 22.99 12C21.26 7.61 16.99 4.5 11.99 4.5C10.59 4.5 9.25 4.75 8.01 5.2L10.17 7.36C10.74 7.13 11.35 7 12 7ZM2 4.27L4.28 6.55L4.73 7C3.08 8.3 1.78 10.02 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.8 19.08L19.73 22L21 20.73L3.27 3L2 4.27Z" fill="#0e2046"/>
                                        </svg>
                                    ) : (
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#0e2046"/>
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="form-options">
                            <div className="remember-me">
                                <input
                                    type="checkbox"
                                    id="rememberMe"
                                    checked={rememberMe}
                                    onChange={e => setRememberMe(e.target.checked)}
                                    disabled={loading}
                                />
                                <label htmlFor="rememberMe">{t('Se souvenir de moi')}</label>
                            </div>
                            <a
                                href="#"
                                onClick={e => { e.preventDefault(); setShowForgotPasswordModal(true); }}
                                className="forgot-password"
                            >
                                {t('Mot de passe oublié ?')}
                            </a>
                        </div>

                        <button type="submit" className="login-button" disabled={loading}>
                            {loading ? t('Connexion en cours...') : t('Se connecter')}
                        </button>
                    </form>

                    <button
                        type="button"
                        className={'cicada-activate-btn' + (isInactive ? ' inactive' : '')}
                        onClick={() => setShowActivationModal(true)}
                        disabled={loading}
                    >
                        {t('Première connexion ? Activez votre compte')}
                    </button>

                    <div className="divider"><span>{t('ou')}</span></div>

                    <div className="social-login">
                        <button type="button" className="social-button sso-button" disabled={loading} style={{ width: '100%' }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path d="M12 1C8.676 1 6 3.676 6 7v1H4a1 1 0 00-1 1v13a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1h-2V7c0-3.324-2.676-6-6-6zm0 2c2.276 0 4 1.724 4 4v1H8V7c0-2.276 1.724-4 4-4zm0 9a2 2 0 110 4 2 2 0 010-4z" fill="currentColor"/>
                            </svg>
                            {t('Se connecter via SSO')}
                        </button>
                    </div>

                    <div className="terms-link">
                        <a href="#">{t("Conditions générales d'utilisation")}</a>
                    </div>
                </div>

                {/* Sélecteur de langue */}
                <div className="language-selector">
                    {['fr', 'en', 'ar'].map((lng, i, arr) => (
                        <React.Fragment key={lng}>
                            <button
                                onClick={() => i18n.changeLanguage(lng)}
                                className={i18n.language === lng ? 'active' : ''}
                            >
                                {lng.toUpperCase()}
                            </button>
                            {i < arr.length - 1 && <span className="language-separator">|</span>}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            {showActivationModal && (
                <ActivationModal
                    onClose={() => setShowActivationModal(false)}
                    t={t}
                    dispatch={dispatch}
                    activationLoading={activationLoading}
                    activationMessage={activationMessage}
                    activationError={activationError}
                />
            )}

            {showForgotPasswordModal && (
                <ForgotPasswordModal onClose={() => setShowForgotPasswordModal(false)} />
            )}
        </>
    );
};

export default Login;
